import type { Meta, StoryFn } from '@storybook/react';
import type { InfoMessageProps } from './InfoMessage';

import { InfoMessage } from './InfoMessage';

const codeString = '<InfoMessage message={message} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/InfoMessage',
  component: InfoMessage,
  argTypes: {
    message: {
      control: 'text',
    },
    hasOwnContainer: {
      control: 'boolean',
    },
  },
  parameters: {
    inspectComponent: InfoMessage,
    codeString: codeString,
  },
} as Meta<InfoMessageProps>;

const Template: StoryFn<InfoMessageProps> = (args) => <InfoMessage {...args} />;

export const InfoMessageExample = Template.bind({});
InfoMessageExample.args = {
  message: 'This is an example info message',
  hasOwnContainer: false,
};
